import React, { ReactNode } from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import Icon, { ICON_SIZE_LARGE } from '@divvy-web/skylab.icon'
import Tile from '@divvy-web/skylab.tile'

import styles from './styles.module.scss'

interface InfoTileAndChecklistProps {
  image: ReactNode
  checklistTitle: ReactNode
  checklistItemsArray: ReactNode[]
}

const InfoTileAndChecklist = ({ image, checklistTitle, checklistItemsArray }: InfoTileAndChecklistProps) => {
  const [getClassName] = useNameFormatter('InfoTileAndChecklist')
  return (
    <div className={styles[getClassName('')]}>
      <Tile>
        <div className={styles[getClassName('image-container')]}>
          <div>{image}</div>
        </div>
      </Tile>
      <div className={styles[getClassName('checklist-title')]}>{checklistTitle}</div>
      {checklistItemsArray?.map((item, index) => (
        <div
          key={index}
          className={styles[getClassName('checklist-item')]}
        >
          <Icon
            key={index}
            className={styles[getClassName('checklist-icon')]}
            name='feedbackSuccess'
            size={ICON_SIZE_LARGE}
          />
          <div className={styles[getClassName('checklist-item')]}>{item}</div>
        </div>
      ))}
    </div>
  )
}

export default InfoTileAndChecklist
